export const env = {
    is_mock_valid: false,
    onProduction: true,
    sentry_trace_rate: 1.0,
    live: true,
    analytics: true,
    extra: {
        finishEpisodeFunc: (stars) => {
            console.log("cheats are not allowed on production environment");
        },
        startEpisodeFunc: () => {
            console.log("cheats are not allowed on production environment");
        },
        finishEpisodeButtonsHTML: ""
    },
    firebaseConfig: {
        default: {
            appName: 'default',
            region: 'eu',
            config: {
                apiKey: "AIzaSyBmeQXuJBcuTRFEfT6KwyiKnsAOFDhzmvo",
                authDomain: "matific-production.firebaseapp.com",
                projectId: "matific-production",
                storageBucket: "matific-production.appspot.com",
                messagingSenderId: "37253563576",
                appId: "1:37253563576:web:c9a54af98466fbd6b2a04d",
                measurementId: "G-ZQDS441KS2"
            },
        },
        log: {
            appName: 'log',
            config: {
                apiKey: "AIzaSyDix8W4fXUhQdjTSlSb2J5P7r6u-5QHUtI",
                authDomain: "matific-production-base.firebaseapp.com",
                projectId: "matific-production-base",
                storageBucket: "matific-production-base.appspot.com",
                messagingSenderId: "201108026861",
                appId: "1:201108026861:web:691eb8d615f9b93cfee3e4",
                measurementId: "G-H1850R8FMM"
            }
        }
    },
    aircraftUrl: 'https://matific.com/home/resources/media/',
    type: 'prod'
}

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/analytics';

class MatificFirestoreService {
    _firebaseApp;
    _firebaseLogApp;
    _firebaseUser;
    _token;
    _db;
    _matificUser;
    _initPromise;
    _firebaseConfig;
    _firebaseRegion;
    DefaultSetting = env.firebaseConfig['default'];
    LogSetting = env.firebaseConfig['log'];


    constructor() {
        console.log('new MatificFirestoreService()', this.version);
    }

    get firebaseRef() {
        return firebase;
    }

    get isReady() {
        return this._db && this._firebaseUser ? true : false;
    }

    get app() {
        return this._firebaseApp;
    }

    get firebaseRegion() {
        return this._firebaseRegion;
    }

    get config() {
        return this._firebaseConfig;
    }

    get version() {
        return BUILD_VERSION;
    }

    getTimestamp(seconds=0, nanoseconds=0) {
        return new firebase.firestore.Timestamp(seconds, nanoseconds);
    }

    get Timestamp() {
        return firebase.firestore.Timestamp;
    }

    initFireBase(settings) {
        if (!this._initPromise) {
            this._initPromise = new Promise((resolve, reject) => {
                if (this.isReady) {
                    resolve(true);
                } else {
                    try {
                        if (!this._firebaseApp) {
                            this._firebaseConfig = settings && settings.firebase_config || this.DefaultSetting.config;
                            this._firebaseRegion = settings && settings.firebase_region || this.DefaultSetting.region;

                            if (firebase.apps.length === 0) {
                                this._firebaseApp = firebase.initializeApp(this._firebaseConfig, this.DefaultSetting.appName);
                                this._firebaseLogApp = firebase.initializeApp(this.LogSetting.config, this.LogSetting.appName);
                            } else {
                                this._firebaseApp = firebase.app(this.DefaultSetting.appName);
                                this._firebaseLogApp = firebase.app(this.LogSetting.appName);
                            }
                            this._db = this._firebaseApp.firestore();
                        }
                    } catch (err) {
                        console.log('Firebase::: initFireBase failed', this.firebaseRegion, err);
                        resolve(false);
                    }

                    this.authFirebase(settings).then(res => {
                        console.log('Firebase::: initFireBase succeed', this.firebaseRegion);
                        resolve(true);
                    }, error => {
                        console.log('Firebase::: initFireBase auth failed', this.firebaseRegion, error);
                        resolve(false);
                    });
                }
            });
        }

        return this._initPromise.then(status => {
            this._initPromise = undefined;
        }, () => {
            this._initPromise = undefined;
        });
    }

    get user() {
        return this._firebaseUser;
    }

    get token() {
        return this._token;
    }

    get matificUser() {
        return this._matificUser;
    }

    get db() {
        return this._db;
    }

    signOut() {
        if(!this._firebaseUser) {
            return Promise.resolve(true);
        }
        try {
            return firebase.auth(this._firebaseApp).signOut();
        } catch(e) {
            console.log('Firebase::: signOut error: ', e);
            return Promise.resolve(false);
        }
    }

    authFirebase(settings) {
        if (settings && settings.user_token) { // login user for slatemath
            return this.authWithJWT(settings.user_token);
        } else { // guest user
            return this.authAnonymously();
        }
    }

    authAnonymously() {
        return new Promise((resolve, reject) => {
            let user = firebase.auth(this._firebaseApp).currentUser; // get login user for login student
            if (user) {
                this._firebaseUser = user;
                resolve(true);
            } else {
                let tries = 1;
                try { // 3 attempts to get the anonymously auth
                    firebase.auth(this._firebaseApp).onAuthStateChanged((user) => {
                        if (user) {
                            this._firebaseUser = user;
                            console.log("Firebase::: auth anonymously", this._firebaseUser);
                            resolve(true);
                        } else if (tries < 4) {
                            firebase.auth(this._firebaseApp).signInAnonymously();
                            console.log('Firebase::: signInAnonymously('+tries+')');
                            tries++;
                        } else {
                            console.log("Firebase::: failed to auth anonymously");
                            reject(false);
                        }
                    });
                } catch (e) {
                    console.log('Firebase::: onAuthStateChanged error: ', e);
                }
            }
        });
    }

    authWithJWT(token) {
        return new Promise((resolve, reject) => {
            if (!token) {
                reject(null);
            } else {
                firebase.auth(this._firebaseApp).signInWithCustomToken(token).then((res) => {
                    this._firebaseUser = res && res.user;
                    this._matificUser = this.convertMatificUserPayload(token);
                    this._token = token;
                    console.log("Firebase::: authWithJWT succeed", res);
                    resolve(true);
                }).catch((e) => {
                    console.log("Firebase::: authWithJWT failed", token, e);
                    reject(null);
                });
            }
        });
    };

    convertMatificUserPayload(token) {
        if(!token) {
            return null;
        }

        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const payload = JSON.parse(jsonPayload);
            const klass_id = ('class_ids' in payload.claims) ? payload.claims.class_ids[0] : null;
            const user_id = ('uid' in payload) ? payload.uid : null;
            console.log("Firebase::: convertMatificUserPayload success");
            return {klass_id, user_id};
        } catch (e){
            console.log("Firebase::: convertMatificUserPayload failed", e);
            return null;
        }
    }

    createScript(src) {
        return new Promise((resolve, reject) => {
            let scriptEl = document.createElement('script');
            scriptEl.async = true;
            scriptEl.src = src;
            scriptEl.onload = resolve;
            scriptEl.onerror = reject;
            document.head.appendChild(scriptEl);
        });
    }

    /*
        LogEvent will send to firebase with env.firebaseLogConfig
     */
    logEvent(eventType, analyticsData) {
        try {
            if(!this._firebaseLogApp) {
                return;
            }
            firebase.analytics(this._firebaseLogApp).logEvent(eventType, analyticsData);
            console.log(`Firebase::: logEvent "${eventType}"`);
        } catch (e) {
        }
    }
}

if(!window.matificFirestoreService) {
    window.matificFirestoreService = new MatificFirestoreService();
}
